/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol, dateCol } from '@integec/grid-tools/lib/cols'

import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import {
  getPjmOaHoliday,
  deletePjmOaHoliday,
  savePjmOaHoliday,
} from 'api/pgads.js'
import { Input, Button, DatePicker } from 'antd'
import CommonScreen from 'admin/component/CommonScreen'

const headers = [
  dateCol({
    ident: 'holidayDate',
    display: 'Holiday Date',
    isKey: true,
    sortOrder: 'desc',
  }),
  strCol({
    ident: 'holiday',
    display: 'Holiday',
    width: 150,
    isRequired: true,
    isKey: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'PJM Holiday Management'

const OaHolidayMgmt = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '70%',
          borderSpacing: '10px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <td>Holiday Date : </td>
            <td>
              <DatePicker
                allowClear={false}
                format="MM/DD/YYYY"
                value={insertData.holidayDateMom}
                onChange={date => {
                  setInsertData({
                    ...insertData,
                    holidayDateMom: date,
                    holidayDate: date.format('YYYY-MM-DD'),
                  })
                }}
              />
            </td>
            <td>Holiday : </td>
            <td>
              <Input
                value={insertData.holiday}
                onChange={e =>
                  setInsertData({ ...insertData, holiday: e.target.value })
                }
                maxLength={15}
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
  return [
    <CommonScreen
      title={title}
      header={headers}
      saveTask={savePjmOaHoliday}
      retrieveTask={getPjmOaHoliday}
      deleteTask={deletePjmOaHoliday}
      altBy={d => d.holiday}
      autoRetrieve
      sortOptions={headers}
      totalWidth={700}
      insertComp={insertEvent && insertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(OaHolidayMgmt)
